module.exports = __webpack_public_path__ + "img/big-list-03.c66c7c8f.jpg";